module.exports = __webpack_public_path__ + "img/Baloot.40703940.png";